import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getAllCoachDetailsStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/allCoachesDetails";
import { allTeamsListStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/allTeams";
import {
  allSeasonStatsListSave,
  allSeasonStatsListStart,
} from "../../../../../../redux/athlete/dashboard/editUserProfile/stats/allSeasonStats";
import { allStatsListStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/stats/allStats";
import { allStatsFieldWithPositionStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/stats/allStatsfieldbasedonpositions";
import { saveStatsListStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/stats/saveAllStats";
import { primaryListStart } from "../../../../../../redux/athlete/onBoarding/primaryPositionList";
import { getUserInfo } from "../../../../../../services/authService";
import { fetchGraphMethod } from "../../../../../../services/httpService";
import { getAllPrimaryPositionsQuery } from "../../../onboarding/positions/PositionsQuery";
import { EnterSeasonStat } from "./Components";
import {
  getAllSeasonStatsQuery,
  getAllStatsQuery,
  saveAllStatsQuery,
  saveSessionStatQuery,
} from "./statsQuery";
import StatsTeamList from "./StatsTeamList";
import { getTeamQuery } from "../teams/TeamQuery";
import swal from "sweetalert";
import toastr from 'toastr'
import InlineLoader from "../../../../../common/InlineLoader";

const StatsSection = (props) => {
  const [enterStatsModal, setEnterStatsModal] = useState(false);
  const [teamData, setTeamData] = useState([]);
  const [fieldList, setFieldList] = useState([]);
  const [savedId, setSavedId] = useState(0);
  const [isEdit, setisEdit] = useState(false);
  useEffect(() => {
    fetchAllPrimaryPosition();
  }, []);
  useEffect(() => {
    props.allTeamsList({
      query: getTeamQuery,
      variables: {
        obj: {
          isverified: 1
        },
      },
    });
  }, []);
  useEffect(() => {
    fetchAllStats();
    if (props.saveStats.data) {
      setSavedId(props.saveStats.data.id);
    }
  }, [props.saveStats.data]);
  useEffect(() => {
    if (
      props.StatsList.data &&
      props.StatsList.data.Stats &&
      props.StatsList.data.Stats.length
    ) {
      setTeamData(props.StatsList.data.Stats);
    }
  }, [props.StatsList.data]);

  const fetchAllStats = () => {
    props.allStatsList({
      query: getAllStatsQuery,
      variables: {
        where: {
          active: 1,
          userid: getUserInfo() ? getUserInfo().id : 0,
          order: "id DESC",
        },
      },
    });
  };
  const fetchAllPrimaryPosition = () => {
    props.primaryListStart({
      query: getAllPrimaryPositionsQuery,
      variables: null,
    });
  };

  const refresh = () => {
    window.location.reload();
  };

  const deleteSeasonFieldsStats = () => {
    swal({
      text: "Stats deleted successfully",
      icon: "success",
    }).then((okay) => {
      if (okay || okay == null) {
        refresh();
      }
    });
  }

  const deleteSaveSeasonFieldsStats = (e, fields) => {
    props.allSeasonStatsListSave({
      query: saveSessionStatQuery,
      variables: fields,
      afterSaveSeasonFieldsStats: deleteSeasonFieldsStats
    });
  };

  const saveSeasonFieldsStats = async (e, fields) => {
    props.saveSeasonStatStart({
      query: saveSessionStatQuery,
      variables: fields,
    });
  };
  useEffect(() => {
    if (
      props.Statsfieldbasedonpositions &&
      props.Statsfieldbasedonpositions.data &&
      props.Statsfieldbasedonpositions.data.Statsfieldbasedonpositions &&
      props.Statsfieldbasedonpositions.data.Statsfieldbasedonpositions.length
    ) {
      setFieldList(
        props.Statsfieldbasedonpositions.data.Statsfieldbasedonpositions
      );
    }
  }, [props.Statsfieldbasedonpositions]);
  const closeModal = (e) => {
    e?.preventDefault();
    setEnterStatsModal(false);
  };

  const saveSeasonStats = async (e, ...data) => {
    const [teamId, selectedPosition, startDate, endDate] = data;
    e.preventDefault();

    let variables = {
      where: {
        userid: getUserInfo() ? getUserInfo().id : 0,
        active: 1,
      },
    };
    let res = await fetchGraphMethod(getAllSeasonStatsQuery, variables, true);
    if (
      res.data &&
      res.data.data &&
      res.data.data.allStats &&
      res.data.data.allStats.Stats
    ) {
      const statList = res.data.data.allStats.Stats;
      if (statList.length == 10) {
        // messagePopup("", "Team Limit Reached. Can't add more team", "warning");
        toastr.warning("Team Limit Reached. Can't add more team", "", {
          progressBar : true,timeOut: 2000,
          closeButton: true, positionClass: "toast-top-full-width",
          showEasing: "swing", fadeIn: 40000,
          preventDuplicates: true,
        })
        return;
      }
    }

    variables = {
      where: {
        userid: getUserInfo() ? getUserInfo().id : 0,
        teamid: teamId.id,
        positionid: selectedPosition[0].id,
        active: 1,
      },
    };
    res = await fetchGraphMethod(getAllSeasonStatsQuery, variables, true);
    if (
      res.data &&
      res.data.data &&
      res.data.data.allStats &&
      res.data.data.allStats.Stats
    ) {
      const statList = res.data.data.allStats.Stats[0];
      let isExist = false;
      if (
        statList &&
        statList.seassionstatStatidMap &&
        statList.seassionstatStatidMap.Seassionstats &&
        statList.seassionstatStatidMap.Seassionstats.length
      ) {
        statList.seassionstatStatidMap.Seassionstats.map((statData) => {
          if (
            statData.seasonenddate == endDate &&
            statData.seasonstartdate == startDate
          ) {
            isExist = true;
          }
        });
        if (isExist) {
          // messagePopup(
          //   "",
          //   "Record Already exists please add a season",
          //   "warning"
          // );
          toastr.warning("Record Already exists please add a season", "", {
            progressBar : true,timeOut: 2000,
            closeButton: true, positionClass: "toast-top-full-width",
            showEasing: "swing", fadeIn: 40000,
            preventDuplicates: true,
          })
          return;
        }
        const statid = statList.id;
        const variables = {
          obj: {
            statid,
            userid: getUserInfo().id,
            seasonstartdate: startDate,
            seasonenddate: endDate,
          },
        };
        saveSeasonFieldsStats(null, variables);
        setSavedId(statid);
        setisEdit(true);
        fetchAllStats();
        return;
      }
    }
    variables = {
      obj: {
        userid: getUserInfo() ? getUserInfo().id : 0,
        teamid: teamId.id,
        positionid: selectedPosition[0].id,
        active: 1,
      },
    };
    res = await fetchGraphMethod(saveAllStatsQuery, variables, true);
    if (res.data && res.data.data && res.data.data.saveStat) {
      const statid = res.data.data.saveStat.id;
      const variables = {
        obj: {
          statid,
          userid: getUserInfo().id,
          seasonstartdate: startDate,
          seasonenddate: endDate,
        },
      };
      saveSeasonFieldsStats(null, variables);
      setSavedId(statid);
      setisEdit(true);
      // messagePopup("", "Seasons saved successfully.", "success");
      toastr.success("Seasons saved successfully.", "", {
        progressBar : true,timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    }

    fetchAllStats();
  };
  const onCancelClick = (e, id, isEdit) => {
    e.preventDefault();
    if (!isEdit) {
      props.saveAllStats({
        query: saveAllStatsQuery,
        variables: {
          obj: {
            userid: getUserInfo() ? getUserInfo().id : 0,
            id: id,
            active: 0,
          },
        },
      });
    }
    setTimeout(() => {
      refresh();
    }, 100);
    fetchAllStats();
  };

  return (
    <div id="StatsSection" className="stats-box-item">
      <h4 className="title">Stats</h4>
      <div className="stats-position-catcher">
      <InlineLoader open={!teamData.length} />
        {teamData.length ? (
          <StatsTeamList
            teamData={teamData}
            fieldList={fieldList}
            onCancel={onCancelClick}
            savedId={savedId}
            isEdit={isEdit}
            onSaveFields={saveSeasonFieldsStats}
            deleteSaveFields={deleteSaveSeasonFieldsStats}
            {...props}
          />
        ) : null}
        <div className="stats-gray-box">
          <p>Would you like to enter stats for another team or position?</p>
          <button
            onClick={() => {
              setEnterStatsModal(true);
            }}
            className="btn green"
            data-toggle="modal"
            data-target="#EnterSeasonStatsModal"
          >
            Enter Stats
          </button>
        </div>
      </div>
      <EnterSeasonStat
        show={enterStatsModal}
        close={closeModal}
        onSave={saveSeasonStats}
        {...props}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    StatsList: state.athlete.editUserProfileData.allStatsLIst,
    SeasonStatsLIst: state.athlete.editUserProfileData.allSeasonStatsLIst,
    primaryPositionList: state.athlete.onBoarding.primaryPositionList,
    saveStats: state.athlete.editUserProfileData.saveStatsLIst,
    allCoachDetails: state.athlete.editUserProfileData.allCoachDetails,
    teamList: state.athlete.editUserProfileData.teamsList,
    Statsfieldbasedonpositions:
      state.athlete.editUserProfileData.allStatsFieldWithPosition,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    allStatsList: (data) => dispatch(allStatsListStart(data)),
    allSeasonStatsList: (data) => dispatch(allSeasonStatsListStart(data)),
    saveSeasonStatStart: (data) => dispatch(allSeasonStatsListSave(data)),
    allSeasonStatsListSave: (data) => dispatch(allSeasonStatsListSave(data)),
    primaryListStart: (data) => dispatch(primaryListStart(data)),
    saveAllStats: (data) => dispatch(saveStatsListStart(data)),
    getAllCoachDetailsStart: (data) => dispatch(getAllCoachDetailsStart(data)),
    allTeamsList: (data) => dispatch(allTeamsListStart(data)),
    allStatsFieldWithPosition: (data) =>
      dispatch(allStatsFieldWithPositionStart(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(StatsSection);
